export default "__VITE_ASSET__CunA$gLI__"